import { render, staticRenderFns } from "./CyberCustomerService.vue?vue&type=template&id=e8225802&scoped=true&"
import script from "./CyberCustomerService.vue?vue&type=script&lang=js&"
export * from "./CyberCustomerService.vue?vue&type=script&lang=js&"
import style0 from "./CyberCustomerService.vue?vue&type=style&index=0&id=e8225802&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8225802",
  null
  
)

export default component.exports